import { SectionHeading } from './ui';

const TERMS = [
  {
    icon: 'ri-stack-line',
    title: 'Khối lượng lệnh',
    desc: 'Số Lot bạn muốn giao dịch cho một vị thế.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Kích thước hợp đồng',
    desc: 'Số đơn vị cơ sở trong một Lot (ngoại hối 100.000, vàng 100 oz).',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Giá hiện tại',
    desc: 'Giá thị trường hiện tại của sản phẩm giao dịch.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Đòn bẩy',
    desc: 'Tỷ lệ đòn bẩy mà nhà môi giới cung cấp cho tài khoản của bạn.',
  },
];

const SYMBOLS = [
  { sym: 'Ký quỹ', meaning: 'Số tiền bị giữ cho lệnh' },
  { sym: 'Giá trị hợp đồng', meaning: 'Giá trị danh nghĩa của vị thế' },
  { sym: 'Đòn bẩy', meaning: 'Tỷ lệ đòn bẩy' },
  { sym: 'Khối lượng', meaning: 'Số lot giao dịch' },
  { sym: 'Kích thước hợp đồng', meaning: 'Đơn vị cơ sở mỗi lot' },
  { sym: 'Giá', meaning: 'Giá thị trường hiện tại' },
];

const EXAMPLE_STEPS = [
  { label: 'Khối lượng lệnh', value: '1 Lot' },
  { label: 'Kích thước hợp đồng', value: '100.000 đơn vị' },
  { label: 'Giá hiện tại', value: '1,0845' },
  { label: 'Giá trị hợp đồng', value: '108.450 USD' },
  { label: 'Đòn bẩy', value: '1:500' },
  { label: 'Ký quỹ yêu cầu', value: '216,90 USD', highlight: true },
];

export default function FormulaSection() {
  return (
    <section>
      <SectionHeading
        eyebrow="Công thức"
        title="Công thức tính ký quỹ"
        subtitle="Công thức đơn giản đứng sau mọi phép tính ký quỹ giao dịch."
      />

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* Left: formula + terms */}
        <div className="space-y-6">
          <div className="rounded-3xl border border-violet-100 bg-gradient-to-br from-violet-50 to-white p-6 md:p-8">
            <p className="text-xs font-semibold uppercase tracking-wider text-violet-600">Công thức chính</p>
            <p className="mt-4 font-mono text-lg font-bold leading-relaxed text-slate-800 md:text-xl">
              Ký quỹ = Giá trị hợp đồng
              <span className="text-violet-600"> ÷ </span>
              Đòn bẩy
            </p>
            <div className="mt-5 h-px w-full bg-violet-100" />
            <p className="mt-5 font-mono text-sm font-semibold leading-relaxed text-slate-600">
              Giá trị hợp đồng = Khối lượng
              <span className="text-violet-600"> × </span>
              Kích thước hợp đồng
              <span className="text-violet-600"> × </span>
              Giá
            </p>
            <div className="mt-5 h-px w-full bg-violet-100" />
            <p className="mt-4 text-[10px] font-semibold uppercase tracking-wide text-violet-400">Ký hiệu</p>
            <div className="mt-2 flex flex-wrap gap-2">
              {SYMBOLS.map((s) => (
                <span
                  key={s.sym}
                  className="inline-flex items-center gap-1.5 rounded-lg bg-white px-2.5 py-1.5 text-[11px] ring-1 ring-violet-100"
                >
                  <span className="font-mono font-semibold text-violet-600">{s.sym}</span>
                  <span className="text-slate-500">{s.meaning}</span>
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {TERMS.map((t) => (
              <div key={t.title} className="rounded-2xl border border-slate-200/80 bg-white p-5">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-violet-50 text-violet-600">
                  <i className={t.icon} />
                </span>
                <p className="mt-3 text-sm font-semibold text-slate-800">{t.title}</p>
                <p className="mt-1 text-xs leading-relaxed text-slate-400">{t.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right: example */}
        <div className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
          <p className="text-sm font-semibold text-slate-800">Ví dụ tính toán</p>
          <p className="mt-1 text-xs text-slate-400">1 Lot EUR/USD ở giá 1,0845 với đòn bẩy 1:500.</p>
          <div className="mt-5">
            {EXAMPLE_STEPS.map((step, i) => (
              <div key={step.label}>
                {i > 0 && (
                  <div className="ml-5 flex h-6 items-center">
                    <i className="ri-arrow-down-line text-slate-300" />
                  </div>
                )}
                <div
                  className={`flex items-center justify-between rounded-xl border px-4 py-3 ${
                    step.highlight ? 'border-fuchsia-200 bg-fuchsia-50/70' : 'border-slate-200/80 bg-slate-50/60'
                  }`}
                >
                  <span className="text-sm text-slate-600">{step.label}</span>
                  <span
                    className={`font-mono text-sm font-bold tabular-nums ${step.highlight ? 'text-fuchsia-600' : 'text-slate-800'}`}
                  >
                    {step.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}